import React, { Component } from 'react';
import { connect } from "react-redux";

import ProjectScopeMobile from './projectScopeMobile';
import ProjectScopeDesktop from './projectScopeDesktop';
import {toggleBathroomVisualizerOpen} from "../../actions/actionFunctions";

class ProjectScope extends Component {

  componentDidMount() {
    if (this.props.bvOpened) {
      this.props.toggleBathroomVisualizerOpen(false);
    }
  }

  render() {
    const windowWidth = this.props.windowWidth;
    return windowWidth ? windowWidth > 991 ? <ProjectScopeDesktop/> : <ProjectScopeMobile/> : null
  }
}

const mapStateToProps = (store) => {
  return {
    windowWidth: store.serverState.windowWidth,
    bvOpened: store.bathroomVisualizerState.bvOpened,
  };
};

export default connect(mapStateToProps, {
  toggleBathroomVisualizerOpen
})(ProjectScope);
